import React, { memo } from 'react'
import { useTheme } from '@mui/material'
import StaticStructureShimmer, { StaticStructureShimmerProps } from './StaticStructureShimmer'

/**
 * Fill colour used for measured regions. Skeletons that draw their own shapes
 * (via `data-shimmer-ignore`) need this to blend with the painted rectangles.
 */
export const useSubtleShimmerColor = (): string => {
    const theme = useTheme()
    return theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)'
}

/**
 * Theme-aware static loading placeholder (no animated gradient sweep).
 * Measures child structure and fills regions with a flat background color.
 */
const SubtleShimmer: React.FC<Omit<StaticStructureShimmerProps, 'backgroundColor'> & { shimmerColor?: string; backgroundColor?: string }> = ({
    shimmerColor: _shimmerColor,
    backgroundColor,
    ...props
}) => {
    const defaultColor = useSubtleShimmerColor()
    const subtleBackgroundColor = backgroundColor ?? defaultColor

    return <StaticStructureShimmer {...props} backgroundColor={subtleBackgroundColor} />
}

export default memo(SubtleShimmer)
